module.exports = __webpack_public_path__ + "static/media/keo-hac-sam-daedong.907e6e38.jpg";